export enum Modules {
  COMMON = "common",
  COMMONS = "commons",
  CORE = "core",
  LOGIN = "login",
  SERVICING = "servicing",
  EMPTY = "empty",
  SHARED_MODULE = "shared-module",
  BANCA = "banca",
  BENEFITS = "benefits",
  BILL = "bill",
  CARD = "card",
  CERTIFICATES = "certificates",
  CERTIFICATION = "certification",
  COMFY = "comfy",
  DEPOSIT = "deposit",
  FUND = "fund",
  FX = "fx",
  KEYLANDING = "keylanding",
  LOANS = "loans",
  SETTINGS = "settings",
  TRANSFER = "transfer",
  TRUST = "trust",

  //
  HOLDINGS = "holdings",
  PAYMENT = "payment",
  INVEST = "invest",
  DISCOVER = "discover",
  OFFERS = "offers",
  PAYMENT_SUBMODULE = "payment-submodule",
  PILOT = "pilot",
  SAMPLE = "sample",
}
